import api from "../../api/index";

const fetchplans = `${process.env.VUE_APP_BASE_URI}/enterprise/plans`;
const subscriptions = `${process.env.VUE_APP_BASE_URI}/enterprise/subscriptions`;
const subscriptionsPost = `${process.env.VUE_APP_BASE_URI}/enterprise/subscriptions`;
const billings = `${process.env.VUE_APP_BASE_URI}/enterprise/billings`;
const cancelSub = `${process.env.VUE_APP_BASE_URI}/enterprise/subscription/cancel/`;
const turnOff = `${process.env.VUE_APP_BASE_URI}/enterprise/cancelDeviceSubscription/`;
const fetchcards = `${process.env.VUE_APP_BASE_URI}/enterprise/cards`;
const fetchActiveSubscribedDevices = `${process.env.VUE_APP_BASE_URI}/enterprise/fetchActiveSubscribedDevices`;
const fetchActiveLicense = `${process.env.VUE_APP_BASE_URI}/enterprise/fetchActiveLicense`;
const renewSub = `${process.env.VUE_APP_BASE_URI}/enterprise/addLicense`;
const fetchCustiomSubscribtion = `${process.env.VUE_APP_BASE_URI}/enterprise/fetchLicense`;

const getDefaultState = () => {
  return {
    plans: [],
    subscriptions: [],
    customSubscriptions: [],
    cards: [],
    status: "",
    activeSubs: [],
    activeLicences: [],
    subMsg: "",
    SubErrMsg: "",
    expPdf: false,
    paginationMeta: {},
  };
};

const state = getDefaultState();

const getters = {
  plans: (state) => state.plans,
  subscriptions: (state) => state.subscriptions,
  subscriptionspaginationMeta: (state) => state.paginationMeta,
  customSubscriptions: (state) => state.customSubscriptions,
  cards: (state) => state.cards,
  activeSubs: (state) => state.activeSubs,
  activeLicences: (state) => state.activeLicences,
  subMsg: (state) => state.subMsg,
  SubErrMsg: (state) => state.SubErrMsg,
  expPdf: (state) => state.expPdf,
};

const actions = {
  async getPlans({ commit }) {
    commit("getplans_request");
    const res = await api.get(fetchplans);
    if (res.data.status === "success") {
      commit("getplans_success", res.data.plans);
    }
    return res;
  },
  async getActiveSubscribedDevices({ commit }, params) {
    commit("fetchActiveSubscribedDevices_request");
    const res = await api.get(fetchActiveSubscribedDevices, {params});
    if (res.data.status === "success") {
      commit("fetchActiveSubscribedDevices_success", res.data);
    }
    return res;
  },

  async getSearchedActiveSubscribedDevices({ commit }, params) {
    commit("fetchActiveSubscribedDevices_request");
    const res = await api.get(`${fetchActiveSubscribedDevices}/search`, {params});
    if (res.data.status === "success") {
      commit("fetchActiveSubscribedDevices_success", res.data);
    }
    return res;
  },
  async fetchActiveLicense({ commit }) {
    commit("fetchActiveLicense_request");
    const res = await api.get(fetchActiveLicense);
    if (res.data.status === "success") {
      commit("fetchActiveLicense_success", res.data.subs);
    }
    return res;
  },

  async getSubscriptions({ commit }) {
    commit("getsubscriptions_request");
    const res = await api.get(subscriptions);
    if (res.data.status === "success") {
      commit("getsubscriptions_success", res.data);
    }
    return res;
  },

  async subscribe({ commit }, plan) {
    commit("subscribe_request");
    const res = await api.post(subscriptionsPost, plan);
    if (res.data.status === "success") {
      commit("subscribe_success");
    }
    return res;
  },

  async fetchCustiomSubscribtion({ commit }, plan) {
    commit("fetchCustiomSubscribtion_request");
    const res = await api.post(fetchCustiomSubscribtion, plan);
    if (res.data.status === "success") {
      commit("fetchCustiomSubscribtion_success", res.data.subs);
    }
    return res;
  },

  async renewSub({ commit }, data) {
    commit("renewSub_request");
    const res = await api.post(renewSub, data);
    if (res.data.status === "success") {
      commit("renewSub_success");
    }
    return res;
  },

  async doCancelSub({ commit }, id) {
    commit("cancelSub_request");
    const res = await api.delete(`${cancelSub}${id}`);
    if (res.data.status === "success") {
      commit("cancelSub_success");
    }
    return res;
  },
  async doTurnOff({ commit }, id) {
    commit("turnOff_request");
    const res = await api.delete(`${turnOff}${id}`);
    if (res.data.status === "success") {
      commit("turnOff_success");
    }
    return res;
  },

  async billings({ commit }, billingInfo) {
    commit("billing_request");
    const res = await api.post(billings, billingInfo);
    if (res.data.status === "success") {
      commit("billing_success");
    }
    return res;
  },

  async getCards({ commit }) {
    commit("getcards_request");
    const res = await api.get(fetchcards);
    if (res.data.status === "success") {
      commit("getcards_success", res.data.cards);
    }
    return res;
  },

  async resetSubscriptionsState({ commit }) {
    await commit("resetsubscriptionsstate_success");
  },

  async updateSucMsg({ commit }, msg) {
    await commit("updateSucMsg_success", msg);
  },
  async updateErrMsg({ commit }, msg) {
    await commit("updateErrMsg_success", msg);
  },

  async exportPdf({ commit }, action) {
    await commit("exportPDf_success", action);
  },
};

const mutations = {
  getplans_request: (state) => (state.status = "loading"),
  getplans_success: (state, plans) => {
    (state.status = "success"), (state.plans = plans);
  },
  fetchActiveSubscribedDevices_request: (state) => (state.status = "loading"),
  fetchActiveSubscribedDevices_success: (state, data) => {
    state.status = "success";
    state.activeSubs = data.devices;
    state.paginationMeta = data.paginationMeta;
  },
  fetchActiveLicense_request: (state) => (state.status = "loading"),
  fetchActiveLicense_success: (state, activeLicences) => {
    (state.status = "success"), (state.activeLicences = activeLicences);
  },
  getcards_request: (state) => (state.status = "loading"),
  getcards_success: (state, cards) => {
    (state.status = "success"), (state.cards = cards);
  },
  getsubscriptions_request: (state) => (state.status = "loading"),
  getsubscriptions_success: (state, data) => {
    state.status = "success";
    state.subscriptions = data.subs;
  },
  subscribe_request: (state) => (state.status = "loading"),
  subscribe_success: (state) => {
    state.status = "success";
  },
  billing_request: (state) => (state.status = "loading"),
  billing_success: (state) => {
    state.status = "success";
  },
  cancelSub_request: (state) => (state.status = "loading"),
  cancelSub_success: (state) => {
    state.status = "success";
  },
  renewSub_request: (state) => (state.status = "loading"),
  renewSub_success: (state) => {
    state.status = "success";
  },
  turnOff_request: (state) => (state.status = "loading"),
  turnOff_success: (state) => {
    state.status = "success";
  },
  fetchCustiomSubscribtion_request: (state) => (state.status = "loading"),
  fetchCustiomSubscribtion_success: (state, subs) => {
    (state.status = "success"), (state.subscriptions = subs);
  },
  resetsubscriptionsstate_success: (state) =>
    Object.assign(state, getDefaultState()),
  updateSucMsg_success: (state, msg) => {
    state.subMsg = msg;
  },
  updateErrMsg_success: (state, msg) => {
    state.SubErrMsg = msg;
  },
  exportPDf_success: (state, action) => {
    state.expPdf = action;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
